module.exports = __webpack_public_path__ + "static/media/logo-chargebee.a772dc38.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/certificate-logos/logo-chargebee.svg
// module id = 2322
// module chunks = 17